const SESSION_ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";

export function generateSessionCode(random: () => number = Math.random): string {
  const characters = Array.from({ length: 6 }, () => {
    const index = Math.floor(random() * SESSION_ALPHABET.length);
    return SESSION_ALPHABET[index] ?? SESSION_ALPHABET[0];
  });

  return `${characters.slice(0, 3).join("")}-${characters
    .slice(3)
    .join("")}`;
}

export function createInviteLink(code: string, origin: string): string {
  return new URL(`/join/${code}`, origin).toString();
}
